module.exports = __webpack_public_path__ + "img/cross-road-mobile.60c65334.png";